// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package48Filled: FC<Package48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M22.5 43.75v-18.9L6 15.3v17.2c0 .533.133 1.033.4 1.5.267.467.633.833 1.1 1.1l15 8.65Zm3 0 15-8.65a2.905 2.905 0 0 0 1.1-1.1c.267-.467.4-.967.4-1.5V15.25l-16.5 9.6v18.9Zm8.2-27.1 6.65-3.85L25.5 4.25a2.975 2.975 0 0 0-1.5-.4c-.533 0-1.033.133-1.5.4l-5.2 3 16.4 9.4ZM24 22.3l6.65-3.9L14.25 9l-6.6 3.85L24 22.3Z" />
        </svg>
    );
};

export default Package48Filled;
